import { render, staticRenderFns } from "./base-evolution-with-info.vue?vue&type=template&id=4fbd1bae&scoped=true"
import script from "./base-evolution-with-info.vue?vue&type=script&lang=js"
export * from "./base-evolution-with-info.vue?vue&type=script&lang=js"
import style0 from "./base-evolution-with-info.vue?vue&type=style&index=0&id=4fbd1bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbd1bae",
  null
  
)

export default component.exports